export default __webpack_public_path__ + "static/media/8.blur.111bd945.jpg";